export const LANG = {
	EN: 'en',
	DE: 'de',
	FR: 'fr'
}
